import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pageTitle: {
    defaultMessage: 'Fulfilled By ShipStation',
    id: 'aCtTQL',
    description: 'title at top of page',
  },
  subTitle: {
    defaultMessage: 'Welcome to Fulfilled by ShipStation',
    id: 'b6ixId',
    description: 'subtitle text for the page',
  },
  valueProposition: {
    defaultMessage: 'Start outsourcing your fulfillment in just a few steps',
    id: '5qrwWj',
    description: 'text shown to highlight value',
  },
  quoteButton: {
    defaultMessage: 'Request a Quote',
    id: 'UbtfgM',
    description: 'button text to start quote process',
  },
  startSetupButton: {
    defaultMessage: 'Start Setup',
    id: '2Vs+os',
    description: 'button text to start setup process',
  },
  applyNowButton: {
    defaultMessage: 'Apply Now',
    id: '7GkkwB',
    description: 'button text to apply for fulfillment service',
  },
  submitNewApplication: {
    defaultMessage: 'Submit New Application',
    description: 'button text to submit a new application if one has already been submitted',
    id: 'cYwOrS',
  },
  continueSetupButton: {
    defaultMessage: 'Continue Setup',
    id: 'WqUZxD',
    description: 'button text to continue setup process when in progress',
  },
  explanationTitle: {
    defaultMessage: 'How does Fulfilled by ShipStation work?',
    id: 'esjVe7',
    description: 'explanation section title',
  },
  step1Explained: {
    defaultMessage: 'Send your inventory to our Fulfilled by ShipStation warehouse(s).',
    id: 'yQVOgw',
    description: 'step 1 of explanation content',
  },
  step2Explained: {
    defaultMessage: 'Orders from your selling channels are routed to our warehouse(s) automatically.',
    id: 'DzaVjC',
    description: 'step 2 of explanation content',
  },
  step3Explained: {
    defaultMessage: 'We quickly fulfill your orders, while you follow along on ShipStation.',
    id: 'ZFLpSQ',
    description: 'step 3 of explanation content',
  },
  step4Explained: {
    defaultMessage: 'Tracking information is sent to you, your selling channels, and your customers.',
    id: 'PHQ7lz',
    description: 'step 4 of explanation content',
  },
  imageAlt: {
    defaultMessage: 'ShipStation Fulfillment Map',
    id: 'ruihlh',
    description: 'alt text for an image of a map',
  },
  footerTitle: {
    defaultMessage: 'Ready to scale your business without the hassle?',
    id: 'G0RE7c',
    description: 'title of the page footer',
  },
  // Benefit cards
  deliverFasterTitle: {
    defaultMessage: 'Deliver Faster with Nationwide Coverage',
    id: 'CPEFUr',
    description: 'benefit card title for faster delivery',
  },
  deliverFasterDescription: {
    defaultMessage: 'Ship faster with our nationwide fulfillment network.',
    id: 'WppxlO',
    description: 'benefit card description for faster delivery',
  },
  competitiveRatesTitle: {
    defaultMessage: 'Competitive, Transparent Rates',
    id: 'YDtOUT',
    description: 'benefit card title for competitive rates',
  },
  competitiveRatesDescription: {
    defaultMessage: 'Simple pricing—pay only for what you ship.',
    id: '8Ax+Sx',
    description: 'benefit card description for competitive rates',
  },
  scaleWithoutLimitsTitle: {
    defaultMessage: 'Scale without limits',
    id: 'mecUuj',
    description: 'benefit card title for scaling',
  },
  scaleWithoutLimitsDescription: {
    defaultMessage: 'Scale easily without the cost of running a warehouse.',
    id: 'pIJG2i',
    description: 'benefit card description for scaling',
  },
  unifyShippingTitle: {
    defaultMessage: 'Unify your shipping and fulfillment',
    id: 'lBDlsC',
    description: 'benefit card title for unified shipping',
  },
  unifyShippingDescription: {
    defaultMessage: 'Centralize fulfillment and view all operations in one place.',
    id: 'AoDPNZ',
    description: 'benefit card description for unified shipping',
  },
  // Process steps
  processStep1Title: {
    defaultMessage: 'Send your products to our warehouses',
    id: 'vxsyHg',
    description: 'process step 1 title',
  },
  processStep1Description: {
    defaultMessage: 'Ship products to our secure fulfillment centers, ready for fast processing.',
    id: 'DnAaBZ',
    description: 'process step 1 description',
  },
  processStep2Title: {
    defaultMessage: 'Route orders to Fulfilled by ShipStation',
    id: 'MbYj8p',
    description: 'process step 2 title',
  },
  processStep2Description: {
    defaultMessage: 'Orders flow directly into our network for quick, accurate fulfillment.',
    id: 'mv1PMR',
    description: 'process step 2 description',
  },
  processStep3Title: {
    defaultMessage: 'Track orders directly in ShipStation',
    id: 'a0IZBh',
    description: 'process step 3 title',
  },
  processStep3Description: {
    defaultMessage: 'View inventory, shipping status, and deliveries all in one place.',
    id: 'XAzTzb',
    description: 'process step 3 description',
  },
  learnMoreButton: {
    defaultMessage: 'Learn more',
    id: 'pKJt/a',
    description: 'learn more button text',
  },
  benefitCardAlt: {
    defaultMessage: 'Benefit illustration',
    id: 'xVF/dE',
    description: 'Alt text for benefit card icons',
  },
  setupProgressTitle: {
    defaultMessage: 'Your setup progress',
    id: 'Bn/yYM',
    description: 'title for fulfillment setup progress section',
  },
  setupProgressText: {
    defaultMessage: '{completedSteps}/{totalSteps} steps complete',
    id: 'Tp7MLn',
    description: 'text showing progress steps completion',
  },
});
